import { createAction } from "redux-actions";

export const getPublishRequestStatuses = createAction("GET_PUBLISH_REQUEST_STATUSES");
export const setPublishRequestStatuses = createAction("SET_PUBLISH_REQUEST_STATUSES");
